import { Component, OnDestroy, OnInit } from "@angular/core";
import {SurveyBaseComponent} from "../survey-base/survey-base.component";
import {environment} from "../../environments/environment";

@Component({
  selector: "app-onboarding",
  templateUrl: "./onboarding.component.html",
  styleUrls: ["./onboarding.component.scss"],
  standalone: false
})
export class OnboardingComponent extends SurveyBaseComponent implements OnInit, OnDestroy {
  showCancelButton: boolean = true;
  defaultContinueText: string = "next";
  surveyDataPath = environment.useMockData ? "assets/mock-data/subjective-feedback-v1-comorbidity.json" : `${window.location.origin}/survey-api/mqui/metadata`;

  continueSelected(): void {
    if (this.surveyTemplate.Questions[this.currentQuestionIndex].hasOwnProperty("SelectedAnswer")){
      this.selectedAnswer = this.surveyTemplate.Questions[this.currentQuestionIndex].SelectedAnswer;
    }

    if (!this.valid) {
      return;
    }
    this.handleQuestionContinueAction();
    this.selectedAnswer = null;
  }

  cancelSelected(): void {
    this.previousQuestion();
  }

  getDefaultCancelText(): string {
    return this.currentQuestion.DefaultCancelText;
  }

  setupSurveyQuestions(): void {
    super.setupSurveyQuestions();

    if (this.surveyTemplate.hasOwnProperty("Questions")) {
      this.surveyTemplate.Questions[0].DefaultCancelText = "";
      this.cancelText = this.getDefaultCancelText();
      this.surveyTemplate.Questions[this.surveyTemplate.Questions.length - 1].DefaultContinueText = "done";
      this.surveyTemplate.Questions[this.surveyTemplate.Questions.length - 1].Action = "submit";

      this.setProgressBar();
    }
  }
}
